import { render, staticRenderFns } from "./form-mail.vue?vue&type=template&id=faa2001a&scoped=true&"
import script from "./form-mail.vue?vue&type=script&lang=js&"
export * from "./form-mail.vue?vue&type=script&lang=js&"
import style0 from "./form-mail.vue?vue&type=style&index=0&id=faa2001a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa2001a",
  null
  
)

export default component.exports